import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPut } from 'api-service';
import { getLatestVersion } from './notificationHelpers';

export const fetchNotifications = createAsyncThunk(
  'notificationReducer/fetchNotifications',
  async (params, thunkAPI) => {
    try {
      const response = await apiGet('/chapaar/api/notification', {
        page: 1,
        paginate: 3,
        ...params,
      });

      const notifications = response.data?.data?.map((notification) => ({
        ...notification.data,
        isRead: notification?.is_read || false,
      }));

      const payload = {
        notifications:
          notifications?.filter((notif) => notif.type !== 'topic_modeling') ??
          [],
        unseenCount: response.data?.meta?.unread,
        total: response.data?.meta?.total,
      };
      const latestVersion = getLatestVersion(response.data?.data ?? []);
      const hasNewVersion =
        localStorage.getItem('seen-version') !==
          latestVersion?.data?.version_name && latestVersion?.status === 0;
      if (hasNewVersion) {
        payload.newVersion = latestVersion.data.version_name;
      }

      return payload;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const seenAllNotifications = createAsyncThunk(
  'notificationReducer/seenAllNotifications',
  async (params, thunkAPI) => {
    try {
      await apiPut('/chapaar/api/notification', params);

      return true;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
